<div class="card-container">
  <mat-card class="card-content" id="force-change-password_container">
    <mat-card-header>
      <img class="force-change-password__logo" src="assets/images/header.png">
    </mat-card-header>
    <mat-card-content>
     <app-change-password-common #changePasswordCommonComponent></app-change-password-common>
    </mat-card-content>
    <mat-card-actions class="actions">
      <button [disabled]="!sendEnabled()"
              (click)="send()"
              mat-flat-button
              color="primary"
              class="primary"
              type="button"
      >{{'Send' | translate}}</button>
    </mat-card-actions>
  </mat-card>
</div>
